import React, { FC } from 'react';

import { useTranslation } from 'app/lang';
import { formatMatchDurationTime } from 'app/lib/matchTimer';

import { useIsMatchComponent } from '../../../../hooks';
import { MatchPeriodLabel } from '../../../MatchPeriodLabel';
import { MatchTimer } from '../MatchTimer';

import dictionary from './MatchTimePeriod.dictionary.json';

type TimePeriodValueProps = {
  matchId: number;
  periodValue: string;
  isReversed?: boolean;
};

export const MatchTimePeriod: FC<TimePeriodValueProps> = ({
  matchId,
  periodValue,
  isReversed = false,
}) => {
  const { t } = useTranslation();
  const isMatchComponent = useIsMatchComponent();

  return (
    <MatchTimer matchId={matchId}>
      {({ seconds }: { seconds: number }) => {
        const durationTime = formatMatchDurationTime(seconds);
        const timeValue = isReversed ? t(dictionary.reverseLabel, { durationTime }) : durationTime;
        const periodData = [periodValue, timeValue];
        const matchPeriodLabel = isMatchComponent ? periodData.join(', ') : periodData.reverse().join(', ');

        return (
          <MatchPeriodLabel data-test="timer-label">
            {matchPeriodLabel}
          </MatchPeriodLabel>
        );
      }}
    </MatchTimer>
  );
};
